<footer class="relative bg-color pt-8 pb-6">


  <div class="container mx-auto sm:px-8 md:px-4 ">
    <div class="flex flex-wrap text-center lg:text-left">


      <div class="w-full lg:w-6/12 px-4">
        <div class="flex flex-wrap items-top mb-6">
          <div class="w-full lg:w-4/12 px-4 ml-auto">
            <span class="block capitalize text-gray-300 text-lg font-semibold mb-2" [routerLink]="['/']">
              Home Page
            </span>
            <ul class="list-unstyled">
              <li>
                <a class="text-white hover:text-blueGray-300 font-semibold block pb-2 text-sm"
                  [routerLink]="['/about']">
                  About Us
                </a>
              </li>

            </ul>
          </div>
          <div class="w-full lg:w-4/12 px-4">
            <span class="block capitalize text-gray-300 text-lg font-semibold mb-2">
              Support
            </span>
            <ul class="list-unstyled">

              <li>
                <a class="text-white hover:text-blueGray-300 font-semibold block pb-2 text-sm"
                  [routerLink]="['/contact-us']">
                  Contact Us
                </a>
              </li>
              <li>
                <a class="text-white hover:text-blueGray-300 font-semibold block pb-2 text-sm" [routerLink]="['/FAQs']">
                  FAQs
                </a>
              </li>

            </ul>
          </div>

          <div class="w-full lg:w-4/12 px-4">
            <span class="block capitalize text-gray-300 text-lg font-semibold mb-2">
              Legal
            </span>
            <ul class="list-unstyled">

              <li>
                <a class="text-white hover:text-blueGray-300 font-semibold block pb-2 text-sm"
                  [routerLink]="['/terms-&-conditions']">
                  Terms of use
                </a>
              </li>
              <li>
                <a class="text-white hover:text-blueGray-300 font-semibold block pb-2 text-sm"
                  [routerLink]="['/privacy-policy']">
                  Privacy Policy
                </a>
              </li>

            </ul>
          </div>

        </div>
      </div>

      <!-- <div class="w-full lg:w-6/12 px-4 ">

        <div class="lg:mb-0 mb-6 lg:text-right ">
          <a href="https://x.com/banan_identity?s=11&t=8xkyEGCA0NVZJ064bW6rvg">
            <button
              class=" text-white  font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
              type="button">
              <i class="fab fa-twitter text-2xl"></i>
            </button>
          </a>


          <a href="https://www.instagram.com/banan_identity?igsh=MWVkeGMyZTEwbXVzNQ==">
            <button
              class="text-white font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
              type="button">
              <i class="fa-brands fa-instagram text-2xl"></i>
            </button>
          </a>
          <div class="py-2 mt-3 ">
            <img src="assets/imges/app-store.png" class=" w-1/2 lg:w-3/12  mx-auto lg:mx-27" alt="">
          </div>
          <div class="py-1">
            <img src="assets/imges/google-play.png" class="w-1/2 lg:w-3/12  mx-auto lg:mx-27" alt="">
          </div>
        </div>


      </div> -->
      <div class="w-full lg:w-6/12 px-4">
        <div class="lg:mb-0 mb-6 md:text-right flex flex-col sm:items-center md:items-end">
      
          <!-- Social Media Icons in a Row -->
          <div class="flex space-x-1 justify-center sm:justify-center md:justify-end">
            <!-- Twitter Button -->
            <a href="https://x.com/banan_identity?s=11&t=8xkyEGCA0NVZJ064bW6rvg" target="_blank">
              <button class="text-white font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none" type="button">
                <i class="fab fa-twitter text-2xl"></i>
              </button>
            </a>
      
            <!-- Instagram Button -->
            <a href="https://www.instagram.com/banan_identity?igsh=MWVkeGMyZTEwbXVzNQ==" target="_blank">
              <button class="text-white font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none" type="button">
                <i class="fa-brands fa-instagram text-2xl"></i>
              </button>
            </a>
          </div>
      
          <!-- App Store and Google Play Images -->
          <div class="py-2 mt-3 flex justify-center sm:justify-center md:justify-end w-full ">
            <img src="assets/imges/app-store.png" class="w-2/6 sm:w-3/12 lg:w-3/12 cursor-pointer" alt="">
          </div>
      
          <div class="py-1 flex justify-center sm:justify-center md:justify-end w-full">
            <img src="assets/imges/google-play.png" class="w-2/6 sm:w-3/12 lg:w-3/12 cursor-pointer" alt="">
          </div>
        </div>
      </div>
      
      
      
    </div>



    <hr class="my-6 border-blueGray-300" />
    <div class="flex flex-wrap items-center md:justify-between justify-center">
      <div class="w-full md:w-4/12 px-4 mx-auto text-center">
        <div class="text-sm text-white font-semibold py-1">
          Copyright © {{ date }} Banan.om
        </div>
      </div>
    </div>
  </div>
</footer>